/** biome-ignore-all lint/suspicious/noTemplateCurlyInString: avoid breaking the custom variable fetching logic */

import { env } from 'next-runtime-env';

export const commonApiURL: string = env('NEXT_PUBLIC_COMMON_API_URL')
  ? env('NEXT_PUBLIC_COMMON_API_URL')!
  : '${NEXT_PUBLIC_COMMON_API_URL}';

export const frApiURL: string = env('NEXT_PUBLIC_FR_API_URL')
  ? env('NEXT_PUBLIC_FR_API_URL')!
  : '${NEXT_PUBLIC_FR_API_URL}';

export const ukApiURL: string = env('NEXT_PUBLIC_UK_API_URL')
  ? env('NEXT_PUBLIC_UK_API_URL')!
  : '${NEXT_PUBLIC_UK_API_URL}';

export const ukSearchApiURL: string = env('NEXT_PUBLIC_UK_SEARCH_API_URL')
  ? env('NEXT_PUBLIC_UK_SEARCH_API_URL')!
  : '${NEXT_PUBLIC_UK_SEARCH_API_URL}';

export const ukI15SearchApiURL: string = env('NEXT_PUBLIC_UK_I15_SEARCH_API_URL')
  ? env('NEXT_PUBLIC_UK_I15_SEARCH_API_URL')!
  : '${NEXT_PUBLIC_UK_I15_SEARCH_API_URL}';

export const frI15SearchApiURL: string = env('NEXT_PUBLIC_FR_I15_SEARCH_API_URL')
  ? env('NEXT_PUBLIC_FR_I15_SEARCH_API_URL')!
  : '${NEXT_PUBLIC_FR_I15_SEARCH_API_URL}';

export const deI15SearchApiURL: string = env('NEXT_PUBLIC_DE_I15_SEARCH_API_URL')
  ? env('NEXT_PUBLIC_DE_I15_SEARCH_API_URL')!
  : '${NEXT_PUBLIC_DE_I15_SEARCH_API_URL}';

export const ukUserServiceApiURL: string = env('NEXT_PUBLIC_UK_USER_SERVICE_API_URL')
  ? env('NEXT_PUBLIC_UK_USER_SERVICE_API_URL')!
  : '${NEXT_PUBLIC_UK_USER_SERVICE_API_URL}';

export const phraseWebAppProjectId: string = env('NEXT_PUBLIC_PHRASE_WEB_APP_PROJECT_ID')
  ? env('NEXT_PUBLIC_PHRASE_WEB_APP_PROJECT_ID')!
  : '${NEXT_PUBLIC_PHRASE_WEB_APP_PROJECT_ID}';

export const loqateApiKey: string = env('NEXT_PUBLIC_LOQATE_API_KEY')
  ? env('NEXT_PUBLIC_LOQATE_API_KEY')!
  : '${NEXT_PUBLIC_LOQATE_API_KEY}';

export const stripeApiKeyFR: string = env('NEXT_PUBLIC_STRIPE_CLIENT_FR')
  ? env('NEXT_PUBLIC_STRIPE_CLIENT_FR')!
  : '${NEXT_PUBLIC_STRIPE_CLIENT_FR}';

export const stripeApiKeyUK: string = env('NEXT_PUBLIC_STRIPE_CLIENT_UK')
  ? env('NEXT_PUBLIC_STRIPE_CLIENT_UK')!
  : '${NEXT_PUBLIC_STRIPE_CLIENT_UK}';

export const googleRecaptchaSiteKeyFR: string = env('NEXT_PUBLIC_RECAPTCHA_SITE_KEY_FR')
  ? env('NEXT_PUBLIC_RECAPTCHA_SITE_KEY_FR')!
  : '${NEXT_PUBLIC_RECAPTCHA_SITE_KEY_FR}';

export const googleRecaptchaSiteKeyUK: string = env('NEXT_PUBLIC_RECAPTCHA_SITE_KEY_UK')
  ? env('NEXT_PUBLIC_RECAPTCHA_SITE_KEY_UK')!
  : '${NEXT_PUBLIC_RECAPTCHA_SITE_KEY_UK}';

export const googleRecaptchaSiteKeyDE: string = env('NEXT_PUBLIC_RECAPTCHA_SITE_KEY_DE')
  ? env('NEXT_PUBLIC_RECAPTCHA_SITE_KEY_DE')!
  : '${NEXT_PUBLIC_RECAPTCHA_SITE_KEY_DE}';
